import React, { useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { RootState } from '../../../../core/store/store';

import { usePanelAccess } from '../../context/PanelAccessContext';

import { isScenarioTeamRole } from '../../panelAccess/panelRoleAccess';

import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';



const ALL_CARDS: (HubCardItem & { referentFunction?: string })[] = [

  { to: '/panel/cta', title: 'Interventions CTA', description: 'Liste et suivi des interventions en cours.', accent: 'sky' },

  { to: '/panel/interventions/create', title: 'Créer un scénario', description: 'Nouveau scénario d’appel (équipe 1 à 4).', accent: 'violet' },

  { to: '/panel/interventions/manage', title: 'Gérer les scénarios', description: 'Modifier les scénarios existants (équipe 1 à 4).', accent: 'violet' },

  { to: '/panel/cta/categories-mission', title: 'Catégories de mission', description: 'Catégories utilisées par le CTA.', accent: 'emerald' },

  { to: '/panel/scenarios', title: 'Création (iframe)', description: 'Ancienne entrée création scénario.', accent: 'slate' },

];



const PanelScenaristeHubV1: React.FC = () => {

  const navigate = useNavigate();

  const { currentUser } = useSelector((state: RootState) => state.user);

  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();

  const roleId = currentUser?.roles_id ?? 0;

  const onScenarioTeam = isScenarioTeamRole(roleId);

  const canEnterHub = hasAccessToSection('salon_scenariste');



  useEffect(() => {

    if (!loading && currentUser && !canEnterHub) {

      navigate('/panel/dashboard', { replace: true });

    }

  }, [loading, currentUser, canEnterHub, navigate]);



  const cards = useMemo(() => {

    return ALL_CARDS.filter((c) => {

      if (!c.referentFunction) return onScenarioTeam || hasReferentFunction('Référent Scénariste') || hasReferentFunction('Référent GR');

      if (onScenarioTeam) return true;

      return hasReferentFunction(c.referentFunction);

    });

  }, [hasReferentFunction, onScenarioTeam]);



  if (!currentUser || loading || !canEnterHub) {

    return null;

  }



  return (

    <PanelHubGrid

      description="Scénarios CTA : l’équipe panel (rôles 1 à 4) peut créer et modifier. Seul le référent scénario (fonction assignée) peut valider un scénario en « Actif »."

      cards={cards}

    />

  );

};



export default PanelScenaristeHubV1;


